import {
  Command,
  CommandEmpty,
  CommandGroup,
  CommandList,
} from "@/components/ui/command";
import { cn } from "@/lib/utils";
import { GroupMenuItem, SelectorSearchInput } from "./menu-parts";
import type { SelectorGroup, SelectorSize } from "./types";

export interface GroupMenuProps {
  groups: SelectorGroup[];
  value?: string;
  onChange: (groupId: string) => void;
  searchable?: boolean;
  searchPlaceholder?: string;
  emptyMessage?: string;
  size?: SelectorSize;
  className?: string;
}

export function GroupMenu({
  groups,
  value,
  onChange,
  searchable = true,
  searchPlaceholder = "Search brand groups...",
  emptyMessage = "No brand groups found.",
  size = "md",
  className,
}: GroupMenuProps) {
  return (
    <Command
      className={cn(
        "h-auto rounded-lg border-neutral-100 py-1 shadow-[0_4px_8px_-2px_rgba(16,24,40,0.10),0_2px_4px_-2px_rgba(16,24,40,0.06)]",
        className
      )}
    >
      {searchable ? (
        <SelectorSearchInput
          placeholder={searchPlaceholder}
          wrapperClassName={cn(
            size === "md" ? "h-10 px-3.5" : "h-8 px-3",
            "gap-2"
          )}
          className="h-full py-0 font-inter text-sm"
        />
      ) : null}
      <CommandList
        focusable={!searchable}
        className="max-h-[min(360px,var(--radix-popover-content-available-height,360px))]"
      >
        <CommandEmpty>{emptyMessage}</CommandEmpty>
        <CommandGroup className="p-0">
          {groups.map((group) => (
            <GroupMenuItem
              key={group.id}
              group={group}
              selected={value === group.id}
              size={size}
              onSelect={() => onChange(group.id)}
            />
          ))}
        </CommandGroup>
      </CommandList>
    </Command>
  );
}
